export interface EmailEmbedSettings {
  previewImages: boolean;
  tablesOfRawData: boolean;
  urlLinks: boolean;
}

export interface EmailAttachmentSettings {
  csv: boolean;
  pdf: boolean;
}

export interface EmailSettings extends EmailEmbedSettings, EmailAttachmentSettings {}
export abstract class ScheduleSubscriptionFacade {
  public abstract settingsChanged(
    subscription: {
      data_previews_enabled: boolean;
      data_tables_enabled: boolean;
      report_links_enabled: boolean;
      csv_attachments_enabled: boolean;
      pdf_attachments_enabled: boolean;
    },
    scheduleModalFacade: { hasUpdate: boolean },
    selected: EmailSettings
  ): void;
}
